export const CONFECTIONERY_LOADING = 'CONFECTIONERY_LOADING';
export const CONFECTIONERY_API_LOADING = 'CONFECTIONERY_API_LOADING';
export const CONFECTIONERY_API_PRODUCTS = 'CONFECTIONERY_API_PRODUCTS';
export const CONFECTIONERY_THEATER = 'CONFECTIONERY_THEATER';
export const CONFECTIONERY_THEATER_DETAIL = 'CONFECTIONERY_THEATER_DETAIL';
export const CONFECTIONERY_PRODUCTS = 'CONFECTIONERY_PRODUCTS';
export const CONFECTIONERY_COMBOS = 'CONFECTIONERY_COMBOS';
export const CONFECTIONERY_DATE = 'CONFECTIONERY_DATE';
